/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { ComponentHtmlOutputCssFile } from './ComponentHtmlOutputCssFile/ComponentHtmlOutputCssFile.entity';
import { ComponentHtmlOutputJsFile } from './ComponentHtmlOutputJsFile/ComponentHtmlOutputJsFile.entity';
import {
  COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_FOOTER,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_HEADER,
} from './types/ComponentHtmlOutputStaticFileLocation.type';

/**
 * The dxp component html output static file entity type.
 * @export
 */
export type EntityComponentHtmlOutputStaticFile = io.TypeOf<typeof ComponentHtmlOutputStaticFile>;

/**
 * The dxp component html output static file entity definition.
 * @export
 */
export const ComponentHtmlOutputStaticFile = io.type(
  {
    file: io.union([ComponentHtmlOutputCssFile, ComponentHtmlOutputJsFile]),
    location: io.union([
      io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_FOOTER),
      io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_HEADER),
    ]),
  },
  `ComponentHtmlOutputStaticFile`,
);
